import { TextButton } from '../../index'

/**
 * @param {string} className The Buttons Styling class name
 * @param {string} text The button's text
 * @param {function} onClick The Function that will be called when the button is clicked
 * @param {boolean} secondaryButton
 *      => If true will render a button with gray background color (e.g. Cancel)
 *      => If false will reder a button with Theme background color (e.g. Save)
 *
 * @returns {React Component} returns a button using the above parameters
 */

const GeneralButton = ({
  children,
  config: { className, text, onClick, secondaryButton, disabled }
}) => {
  return (
    <TextButton
      className={className}
      clickHandler={onClick}
      secondaryButton={!!secondaryButton}
      disabled={disabled}
    >
      {children || text}
    </TextButton>
  )
}

export default GeneralButton
